import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useUserStore } from './user'
import {
  chatMessageType,
  gameUserInfoType,
  groupItemType,
  sendDataType
} from '@/types/Customer/Reply'
import { getGameUserInfoApi } from '@/api/customer/reply'
import { useEventBus } from '@/hooks/event/useEventBus'
import chatStorage from '@/utils/chatStorage'
import { TabType } from '@/constants/Customer/Reply'
import { MessageType } from '@/api/chat/enums'
const { emit } = useEventBus()
import { ElNotification } from 'element-plus'
import { isKefuId } from '@/utils/kefuUtils'

export const WS_STATUS = {
  SUCCESS: 'SUCCESS',
  FALL: 'FALL',
  CLOSE: 'CLOSE'
}

export const webSocketStore = defineStore(
  'webSocket',
  () => {
    /******* 是否已打开客服页********/
    const isCurrentPage = ref(false)
    /****** 当前聊天、聊天分组*******/
    const tabActiveName = ref(TabType.Msg)

    /************WebSocket连接start**************/
    // WebSocket 实例
    const socketInstance = ref<WebSocket | null>(null)

    const wsStatus = ref(WS_STATUS.CLOSE)
    const socketTaskTime = ref<any>(null)
    /****心跳任务，定时检查状态自动重连*******/
    const taskFn = () => {
      closeTaskFn()
      socketTaskTime.value = setInterval(() => {
        if (wsStatus.value != WS_STATUS.SUCCESS) {
          initSocketInstance()
        }
      }, 8000)
    }
    const closeTaskFn = () => {
      if (socketTaskTime.value) {
        clearInterval(socketTaskTime.value)
        socketTaskTime.value = null
      }
    }

    const initFn = () => {
      initSocketInstance()
      taskFn()
    }

    const closeSocket = () => {
      clearSocketInstance()
      closeTaskFn()
    }

    // 初始化 WebSocket 连接
    const initSocketInstance = () => {
      // 如果已经存在连接，先关闭
      if (socketInstance.value && wsStatus.value == WS_STATUS.SUCCESS) {
        // socketInstance.value.close()
        return
      }

      // 获取token
      const userStore = useUserStore()
      const token = userStore.getToken || ''

      if (!token) {
        // 未登录
        closeTaskFn()
        return
      }

      // 创建新的 WebSocket 连接  || 'wss://brchatapi.p2pagentmall.com'
      const baseUrl = import.meta.env.VITE_API_WS_BASE_PATH
      const url = `${baseUrl}/ws/userConnect`

      // 添加 protocols 参数
      const protocols = token ? [`Bearer${token}`] : []

      socketInstance.value = new WebSocket(url, protocols)

      // 设置连接成功回调
      socketInstance.value.onopen = () => {
        console.log('连接成功')
        wsStatus.value = WS_STATUS.SUCCESS

        // 初始化当前聊天
        initCustomerSend()
        // 初始化分组
        initCustoerCateSend()
      }

      // 设置接收消息回调
      socketInstance.value.onmessage = (event) => {
        if (event.data) {
          const data = JSON.parse(event.data)
          onmessage(data)
        }
      }

      // 设置错误回调
      socketInstance.value.onerror = () => {
        wsStatus.value = WS_STATUS.FALL
      }

      // 设置连接关闭回调
      socketInstance.value.onclose = () => {
        console.log('连接关闭')
        wsStatus.value = WS_STATUS.CLOSE
      }
    }

    // 设置 WebSocket 实例
    const setSocketInstance = (socket: WebSocket | null) => {
      socketInstance.value = socket
    }

    // 清空 WebSocket 实例
    const clearSocketInstance = () => {
      if (socketInstance.value) {
        socketInstance.value.close()
      }
      socketInstance.value = null
    }

    // 处理接收消息
    const onmessage = (data: any) => {
      console.log('接收的消息:', data)
      switch (data.cmd) {
        case 'friend':
          friendFn(data.data)
          break
        case 'sendfriend':
          sendfriendFn(data.data)
          break
        case 'initcustomercate':
          initcustomercate(data.data)
          break
        case 'initcustomer':
          initcustomer(data.data)
          break
        case 'event':
          console.log('event')
          onEvent(data.data)
          break
      }
    }

    // WS事件通知
    const onEvent = (data: any) => {
      console.log('1')
      switch (data.event) {
        case 'user_online':
          updateUmsgOnline(data.user_id, data.is_online)
          break
        case 'user_read':
          updateUmsgRead(data.user_id, data.cate_id)
          break
      }
    }
    // 接收实时消息
    const sendfriendFn = (data: chatMessageType) => {
      if (isKefuId(data.sender_id)) {
        data.uid = data.receiver_id
        data.avatar = data.receiver_avatar
        data.nickname = data.receiver_nickname
        data.remark = data.receiver_remark
      } else {
        data.uid = data.sender_id
        data.avatar = data.send_avatar
        data.nickname = data.send_nickname
        data.remark = data.send_remark
      }

      const isPush = saveChatMessages(data)
      if (isPush) {
        const gameUserInfo = {
          uid: data.uid,
          sender_id: data.sender_id,
          avatar: data.avatar,
          nickname: data.nickname,
          remark: data.remark,
          message_type: data.message_type,
          last_message: data.message,
          last_time: data.time,
          is_top: data.is_top,
          cate_id: data.cate_id
        } as gameUserInfoType
        saveOrUpdateUserMsgList(gameUserInfo)
      }
      emit('chatScrollbottom')
    }
    const friendFn = (data: any) => {
      batchChatMessages(data.messages)
      updateUmsgRedNum()
    }
    // 消息
    const currentUser = ref(null as gameUserInfoType | null)
    const sendMsg = (msg: sendDataType | any) => {
      const userStore = useUserStore()
      const userInfo = userStore.getUserInfo

      const msgStr = JSON.stringify(msg)
      // console.log('wsStatus.value ', wsStatus.value)
      // console.log('socketInstance.value ', socketInstance.value)
      if (wsStatus.value === WS_STATUS.SUCCESS && socketInstance.value) {
        socketInstance.value.send(msgStr)
      }
      switch (msg.cmd) {
        case 'sendfriend': {
          const data = msg.data
          if (data) {
            const chatMsg = {
              uid: data.touser,
              sender_id: userInfo?.id || 0,
              message_type: data.message_type,
              message: data.message,
              time: new Date().toISOString(),
              quote: data.quote || '',
              uuid: data.uuid || '',
              message_translation: data.message_translation
            } as chatMessageType
            saveChatMessages(chatMsg)
            // console.log("currentUser",currentUser.value)
            const gameUserInfo = {
              uid: data.touser,
              message_type: data.message_type,
              last_message: data.message,
              avatar: currentUser.value?.avatar || '',
              nickname: currentUser.value?.nickname || '',
              remark: currentUser.value?.remark || '',
              last_time: new Date().toISOString(),
              is_top: currentUser.value?.is_top,
              cate_id: currentUser.value?.cate_id
            } as gameUserInfoType
            saveOrUpdateUserMsgList(gameUserInfo, true)
          }
          break
        }
      }
    }

    const userMsgList = ref([] as gameUserInfoType[])

    const userStore = useUserStore()

    // 监听userMsgList变化，保存到localStorage
    watch(
      userMsgList,
      (newUserMsgList) => {
        const userId = userStore.getUserInfo?.id
        if (userId) {
          localStorage.setItem(`chatUser_${userId}`, JSON.stringify(newUserMsgList))
        }
      },
      { deep: true }
    )

    // isSend 0 自己发送 1 接收
    const saveOrUpdateUserMsgList = (userMsg: gameUserInfoType, isSend: boolean = false) => {
      const index = userMsgList.value.findIndex((item) => item.uid == userMsg.uid)
      if (index >= 0) {
        userMsgList.value[index].last_time = userMsg.last_time
        userMsgList.value[index].message_type = userMsg.message_type
        userMsgList.value[index].last_message = userMsg.last_message
        // 接收消息才会有未读数量
        if (!isSend && !isKefuId(userMsg.sender_id)) {
          userMsgList.value[index].read_num = (userMsgList.value[index].read_num ?? 0) + 1 || 1
        }
        // 正在聊天
        if (currentUser.value?.uid == userMsg.uid) {
          userMsgList.value[index].read_num = 0
          currentUser.value.avatar = userMsg.avatar
        }

        /****接收消息才要更新聊天对象的头像昵称，向聊天对象发送消息时不传以下参数则不触发更新***/
        if (userMsg.remark) {
          userMsgList.value[index].remark = userMsg.remark
        }
        if (userMsg.nickname) {
          userMsgList.value[index].nickname = userMsg.nickname
        }
        if (userMsg.avatar) {
          userMsgList.value[index].avatar = userMsg.avatar
        }
      } else {
        // 正在聊天
        if (currentUser.value?.uid == userMsg.uid) {
          userMsg.read_num = 0
        }
        userMsgList.value.unshift(userMsg)
        // 接收消息才会有未读数量
        if (!isSend && !isKefuId(userMsg.sender_id)) {
          userMsg.read_num = 1
        }
      }
      if (!isSend) {
        // 是否显示全局消息通知

        showNotificationIfNeed(userMsg)
        //更新头像
        updateUmsgAvater(userMsg.uid, userMsg.avatar)
        addUmsgGroupRedNum(userMsg.uid)
      }
      updateULastMessage(userMsg.uid, userMsg)
    }

    // 用于决定是否显示通知
    const showNotificationIfNeed = (userMsg: gameUserInfoType) => {
      // && !isCurrentPage.value
      if (!isKefuId(userMsg.sender_id)) {
        ElNotification.info({
          title: '有新消息',
          dangerouslyUseHTMLString: true,
          message: `<div>${userMsg.remark || userMsg.nickname}发来1条新消息</div>`,
          type: 'primary'
        })

        // 添加新消息提示音
        const audio = new Audio('/mp3/tisi.mp3')
        audio.play().catch((error) => {
          console.error('Error playing notification sound:', error)
        })
      }
    }

    /*********聊天消息**********/
    const chatMessages = ref([] as chatMessageType[])

    const saveChatMessages = (userMsg: chatMessageType) => {
      const uchatMessages = chatStorage.getList(userStore.getUserInfo?.id as number, userMsg.uid)
      const index = uchatMessages.findIndex((item) => item.uuid == userMsg.uuid)
      if (index >= 0) {
        return false
      } else {
        uchatMessages.push(userMsg)
        chatStorage.setList(userStore.getUserInfo?.id as number, userMsg.uid, uchatMessages)

        if (currentUser.value?.uid == userMsg.uid) {
          chatMessages.value.push(userMsg)
          if (userMsg.message_type == MessageType.NOTICE) {
            // 消息撤回
            const isReadIndex = chatMessages.value.findIndex(
              (x) => x.message_seq == userMsg.del_message_seq
            )
            if (isReadIndex !== -1) {
              chatMessages.value.splice(isReadIndex, 1)
            }
          }
        }
        return true
      }
    }
    const batchChatMessages = (userMsgs: chatMessageType[]) => {
      if (userMsgs.length) {
        const reversedMsgs = userMsgs.reverse()
        chatStorage.setList(
          userStore.getUserInfo?.id as number,
          currentUser?.value?.uid as number,
          reversedMsgs
        )
        if (currentUser.value?.uid == currentUser?.value?.uid) {
          chatMessages.value = reversedMsgs
        }
        const last_msg = chatMessages.value[chatMessages.value.length - 1]

        const gameUserInfo = {
          // uid: last_msg.sender_id, //聊天对象 id
          sender_id: last_msg.sender_id,
          // avatar: string
          // nickname: string
          // remark: string
          message_type: last_msg.message_type,
          last_message: last_msg.message,
          last_time: last_msg.time,
          is_top: last_msg.is_top,
          is_top_incate: last_msg.is_top_incate,
          cate_id: last_msg.cate_id,
          is_online: last_msg.is_online
        } as gameUserInfoType

        if (isKefuId(gameUserInfo.sender_id)) {
          gameUserInfo.avatar = last_msg.receiver_avatar || ''
          gameUserInfo.nickname = last_msg.nickname || ''
          gameUserInfo.remark = last_msg.remark || ''
        }
        // updateULastTime(currentUser?.value?.uid as number, last_msg.time)
        updateULastMessage(currentUser?.value?.uid as number, gameUserInfo)
        emit('chatScrollbottom')
      }
    }
    /********消息列表end******** */
    function getGameUserInfo(newCurrentUser) {
      getGameUserInfoApi({ user_id: newCurrentUser.uid })
        .then((res) => {
          gameUserInfo.value = res.data || null
        })
        .catch(() => {
          gameUserInfo.value = null
        })
    }

    /*****游戏用户信息*****/
    const gameUserInfo = ref(null as any)
    // 监听currentUser变化，触发getGameUserInfo
    watch(
      () => currentUser.value,
      (newCurrentUser) => {
        if (newCurrentUser) {
          // chatMessages.value =
          //   chatStorage.getList(userStore.getUserInfo?.id as number, newCurrentUser.uid) || []

          getGameUserInfo(newCurrentUser)

          // 先清除聊天记录
          chatMessages.value = []
          // 请求历史聊天记录
          const sendDate = {
            cmd: 'friend',
            data: {
              touser: newCurrentUser.uid,
              page: 1,
              page_init: 100
            }
          }
          // console.log("将要发送----", sendDate)
          sendMsg(sendDate)
          // 聊天区域滚动到底
          emit('chatScrollbottom')

          // 标记为已读
          emit('unreadFn')
          // 更新用户未读标识数量
          // if (!oldCurrentUser || newCurrentUser.uid != oldCurrentUser.uid) {
          //   updateUmsgRedNum(newCurrentUser.uid)
          // }
        } else {
          gameUserInfo.value = null
        }
      },
      { immediate: true }
    )

    //ws分组信息 初始化
    const initCustoerCateSend = () => {
      const sendData = {
        cmd: 'initcustomercate' as const,
        data: null
      } as sendDataType

      sendMsg(sendData)
    }

    const initCustomerSend = () => {
      const sendData = {
        cmd: 'initcustomer',
        data: {
          is_cate: 0 // 1聊天分组，0当前聊天，默认0
        }
      }
      console.log('准备发送', sendData)
      sendMsg(sendData)
    }

    const initcustomer = (data) => {
      if (!data) {
        data = []
      }
      userMsgList.value = data
    }

    const groupList = ref([] as groupItemType[])
    const initcustomercate = (data: any) => {
      if (!data) {
        data = []
      }
      groupList.value = data
      // .map(x=>{
      //   xisOpen = false
      //   return x
      // })
    }

    // 根据uid查询这一条数据的位置
    const getGoupIndexByUid = (uid: number): { gIndex: number; uIndex: number } => {
      let gIndex = -1
      let uIndex = -1
      groupList.value.forEach((gItem, gi) => {
        gItem.userinfo.forEach((UserItem, ui) => {
          if (UserItem.uid == uid) {
            gIndex = gi
            uIndex = ui
          }
        })
      })

      return {
        gIndex,
        uIndex
      }
    }
    /**********最新消息**********/
    const updateULastMessage = (uid: number, gameUserInfo: gameUserInfoType) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          group.userinfo[uIndex].last_message = gameUserInfo.last_message
          group.userinfo[uIndex].last_time = gameUserInfo.last_time
          group.userinfo[uIndex].message_type = gameUserInfo.message_type
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].last_message = gameUserInfo.last_message
        userMsgList.value[index].last_time = gameUserInfo.last_time
        userMsgList.value[index].message_type = gameUserInfo.message_type
      }
    }
    /**********最新时间**********/
    // const updateULastTime = (uid: number, last_time: string) => {
    //   const { gIndex, uIndex } = getGoupIndexByUid(uid)
    //   if (gIndex >= 0 && uIndex >= 0) {
    //     const group = groupList.value[gIndex]
    //     if (group && group.userinfo[uIndex]) {
    //       group.userinfo[uIndex].last_time = last_time
    //     }
    //   }
    //   const index = userMsgList.value.findIndex((item) => item.uid == uid)
    //   if (index >= 0) {
    //     userMsgList.value[index].last_time = last_time
    //   }
    // }
    // 增加用户在群组的未读数量
    const addUmsgGroupRedNum = (uid) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          // 组消息数量
          // if (
          //   groupList.value[gIndex].total_unread !== undefined &&
          //   group.userinfo[uIndex].read_num !== undefined &&
          //   groupList.value[gIndex].total_unread >= group.userinfo[uIndex].read_num
          // ) {
          //   groupList.value[gIndex].total_unread = groupList.value[gIndex].total_unread + 1
          // }
          // 组内用户未读标识
          group.userinfo[uIndex].read_num = (group.userinfo[uIndex].read_num ?? 0) + 1 || 1
        }
      }
    }
    // 更新用户未读标识数量 为 0
    const updateUmsgRedNum = () => {
      if (!currentUser.value) return
      const uid = currentUser.value.uid
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          // 组消息数量
          // if (
          //   groupList.value[gIndex].total_unread !== undefined &&
          //   group.userinfo[uIndex].read_num !== undefined &&
          //   groupList.value[gIndex].total_unread >= group.userinfo[uIndex].read_num
          // ) {
          //   groupList.value[gIndex].total_unread =
          //     groupList.value[gIndex].total_unread - group.userinfo[uIndex].read_num
          // } else {
          //   groupList.value[gIndex].total_unread = 0
          // }
          // 组内用户未读标识
          group.userinfo[uIndex].read_num = 0
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].read_num = 0
      }

      const filterList = chatMessages.value.filter((item) => item.message_seq)

      if (filterList.length) {
        const senData = {
          cmd: 'read',
          data: {
            type: 2,
            ToUser: uid, //
            Seq: filterList[filterList.length - 1].message_seq // 消息的大序号
          }
        }
        sendMsg(senData)
      }
    }
    // 更新用户在线状态
    const updateUmsgOnline = (uid: number, is_online: boolean) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          // if (is_online) {
          //   groupList.value[gIndex].online_num = groupList.value[gIndex].online_num + 1
          // } else {
          //   groupList.value[gIndex].online_num = groupList.value[gIndex].online_num - 1
          // }
          group.userinfo[uIndex].is_online = is_online
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].is_online = is_online
      }
    }

    //
    const updateUmsgRead = (uid: number, cate_id: number) => {
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].cate_id = cate_id
      }
    }
    //  更新用户置顶信息
    const updateUmsgIsTop = (uid: number, is_top: number) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          group.userinfo[uIndex].is_top = is_top
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].is_top = is_top
      }
    }

    // 更新群内置顶信息
    const updateUmsgIsTopIncate = (uid: number, is_top_incate: number) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          group.userinfo[uIndex].is_top_incate = is_top_incate
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].is_top_incate = is_top_incate
      }
    }

    // 更新用户备注信息
    const updateUmsgRemark = (uid: number, remark: string) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          group.userinfo[uIndex].remark = remark
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].remark = remark
      }
    }

    // 跟新用户头像
    const updateUmsgAvater = (uid: number, avatar: string) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          group.userinfo[uIndex].avatar = avatar
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].avatar = avatar
      }
    }

    // 更新用户分组信息
    const updateUmsgGroup = (uid: number, cate_id: number) => {
      const { gIndex, uIndex } = getGoupIndexByUid(uid)
      if (gIndex >= 0 && uIndex >= 0) {
        const group = groupList.value[gIndex]
        if (group && group.userinfo[uIndex]) {
          if (group.id != cate_id) {
            const newGIndex = groupList.value.findIndex((x) => x.id == cate_id)

            // 从当前分组中删除该用户
            if (newGIndex >= 0) {
              const setUser = group.userinfo[uIndex]
              setUser.cate_id = cate_id
              group.userinfo.splice(uIndex, 1)
              groupList.value[newGIndex].userinfo.push(setUser)
              // groupList.value[newGIndex].total_num++
              // if (groupList.value[gIndex].total_num >= 0) {
              //   groupList.value[gIndex].total_num--
              // }
              // if (setUser.is_online) {
              //   groupList.value[newGIndex].online_num++
              //   if (groupList.value[gIndex].online_num >= 0) {
              //     groupList.value[gIndex].online_num--
              //   }
              // }
            }
          }
        }
      }
      const index = userMsgList.value.findIndex((item) => item.uid == uid)
      if (index >= 0) {
        userMsgList.value[index].cate_id = cate_id
      }
    }

    return {
      isCurrentPage,
      tabActiveName,
      wsStatus,
      groupList,
      gameUserInfo,
      currentUser,
      userMsgList,
      chatMessages,
      socketInstance,
      getGameUserInfo,
      initCustomerSend,
      updateULastMessage,
      updateUmsgRedNum,
      initFn,
      closeSocket,
      initCustoerCateSend,
      updateUmsgIsTop,
      updateUmsgIsTopIncate,
      updateUmsgRemark,
      updateUmsgGroup,
      sendMsg,
      saveOrUpdateUserMsgList,
      showNotificationIfNeed,
      initSocketInstance,
      setSocketInstance,
      clearSocketInstance
    }
  },
  {
    persist: {
      pick: [
        'isCurrentPage',
        'tabActiveName',
        'groupList',
        'gameUserInfo',
        'currentUser',
        'userMsgList',
        'chatMessages'
      ]
    }
  }
)
